if (!customElements.get('prost-sticky-header')) {
  customElements.define('prost-sticky-header', class extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      const header = this.querySelector('.site-header');
      if (!header) return;
      this.refresh = () => {
        const ticker = document.querySelector('.prost-event-ticker-section');
        const mobileBar = document.querySelector('.prost-mobile-bar');
        const bottom = header.getBoundingClientRect().bottom;
        document.documentElement.style.setProperty('--prost-nav-bottom', `${bottom}px`);
        document.documentElement.style.setProperty('--prost-mobile-bar-height', `${mobileBar?.getBoundingClientRect().height || 0}px`);
        document.documentElement.style.setProperty('--prost-top-stack', `${bottom + (ticker && !ticker.hidden ? ticker.getBoundingClientRect().height + 9 : 0)}px`);
        if (ticker) {
          const leaving = window.scrollY >= 32;
          ticker.classList.toggle('is-leaving', leaving);
          ticker.inert = ticker.hidden || leaving;
          ticker.setAttribute('aria-hidden', String(ticker.hidden || leaving));
        }
      };
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.refresh(); });
      };
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(header);
      this.observeTicker = () => {
        const ticker = document.querySelector('.prost-event-ticker-section');
        const mobileBar = document.querySelector('.prost-mobile-bar');
        if (ticker) this.resize.observe(ticker);
        if (mobileBar) this.resize.observe(mobileBar);
        this.schedule();
      };
      window.addEventListener('scroll', this.schedule, { ...options, passive: true });
      window.addEventListener('resize', this.schedule, options);
      window.addEventListener('pageshow', this.schedule, options);
      document.addEventListener('shopify:section:load', this.observeTicker, options);
      document.addEventListener('shopify:section:unload', this.schedule, options);
      this.observeTicker();
    }
    disconnectedCallback() {
      this.listeners?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}
